import CalendarHead from "./calendarHead";
import CalendarBody from "./calendarBody";
import { CalendarProvider } from "../context";
import "./calendar.scss";

export default function Calendar() {
  return (
    <>
      <div className="calendar-rm flex">
        <div className="flex-1">
          <CalendarProvider>
            <CalendarHead />
            <CalendarBody />
          </CalendarProvider>
        </div>
      </div>
    </>
  );
}
